import * as Optional from "optional-js";

import i18n from 'l10n';
import Handlebars from 'handlebars';
import UserModel from 'js/models/userrelatedinfo.model';
import BaseView from 'js/views/subscribers.base.view';
import RowView from 'js/views/subscriber.report.listgroup.row.view';
import InnerView from 'js/views/group.report.tile.view';
import MyModel from 'js/models/subscriber.groups.model';
import SubscribersCollection from 'js/models/subscribers.report.collection';
import GroupsCollection from 'js/models/groups.collection';
import Template from 'js/templates/selection.hbs';
import DDRView from 'js/views/subscriber.detailed.delivery.report.view';
import {_, Backbone} from "backboneAdapter";
import {domain, el, on, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

@template(Template)
@el("#contacts-container")
@domain(".page")
class SubscriberListView extends BaseView {
    report = null;

    @on('click .bside')
    handleClickBSide() {
        $(".card").removeClass("is-flipped");
        this.ddrView.remove();
        delete this.ddrView;
    }

    @on('click #listview .subscriber-row')
    handleSubscriberRowClick(e) {
        e.preventDefault();
        //target id is subscriber-{{subscriptionId}}.
        // It's just the way it is. Don't ask questions you don't wanna read the answer to. Deep down you already know why.
        const $cT = $(e.currentTarget);
        const subscriptionId = $cT.attr('id').replace('subscriber-', '');
        const contactBubbleClone = $cT.clone()
            .css("position", "unset")
            .removeAttr("id");
        contactBubbleClone.find("a").removeAttr("href");
        const viewDiv = $('<div id="detailed-contact-delivery-view">').append(contactBubbleClone);
        $(".contact-details").append(viewDiv);

        this.ddrView = new DDRView({
            el: "#detailed-contact-delivery-view",
            subscriptionId: subscriptionId,
            campaignId: this.campaignId
        });
        $(".card").addClass("is-flipped");
    }

    @on('click .selection-tab-btn')
    changeVisibleTargetingTab(evt) {
        const $clickedTabButton = $(evt.currentTarget);
        const targetId = $clickedTabButton.data("id");
        const targetTags = $clickedTabButton.data("tags");

        const $currentActiveTabButton = $(".selection-tab-btn.active");
        const $currentActiveTab = $(".selection-tab.active");
        const $currentTagsContainer = $(".tags-container .tag-container.active");

        $currentActiveTabButton.removeClass("bg-funkyOrange fg-white active").addClass("bg-lightGray fg-black");
        $clickedTabButton.removeClass("bg-lightGray fg-black").addClass("bg-funkyOrange fg-white active");

        $currentActiveTab.removeClass("active");
        $currentTagsContainer.removeClass("active");

        $("#"+ targetId).addClass("active");
        $(".tags-container").find(".tm-tag").hide();
        $(".tags-container").find("."+ targetTags +"-contact-tag").show();
    }

    @on('keyup #contacts-container .searchbox')
    doContactSearch() {
        return super.dosearch();
    }

    constructor(options) {
        super(options);
        this.inIncludedGroupSearch = false;
        this.totalIncludedGroupsLength = 0;
        this.inMessageReport = true;
        this.CCview = options.CCview;

        this.campaignChannel = options.campaignChannel;

        this.campaignId = options.campaignId;

        this.voucherId = options.voucherId;

        this.surveyId = options.surveyId;

        this.includedGroups = options.includedGroups;

        this.contentForUniqueCode = options.contentForUniqueCode;

        this.urlForUniqueCode = options.urlForUniqueCode;

        this.optoutForUniqueCode = options.optoutForUniqueCode;

        this.SubscriberView = RowView;

        this.subscribersCollection = new SubscribersCollection();

        this.GroupView = InnerView;

        this.groupsCollection = new GroupsCollection();
        this.groupsCollection.bind("reset add remove", this.renderGroupsCollection, this);

        this.userModel = new UserModel();
        this.userModel.fetch({
            error(data) {
                console.error(data);
            }
        });
    }

    delegateEvents(events) {
        this.cid = 'add-dialog';
        Backbone.View.prototype.delegateEvents.call(this, events);
    }

    async load() {
        this.model = new MyModel();

        this.model.set("campaignTemplateType", this.CCview.model.get("campaignTemplateType"));
        await this.groupsCollection.fetch({
            error(model, status) {
                console.error(status.status);
                $.Notify.error(i18n.t("subscriber.nogroups"));
            }
        });
        this.render(this);
        //Override text in the selection template, in the case of the report
        if (this.CCview.model.get("campaignTemplateType") === "SMART_NOTIFICATION") {
            this.$("#nocontactsinmsgconfigsearch").text(i18n.t("message.noResponders"));
        } else {
            this.$("#nocontactsinmsgconfigsearch").text(i18n.t("message.messagereportnocontacts"));
        }

        this.$("#nogroupssearchmsg").text(i18n.t("message.messagereportnogroups")); //Override text in the selection template, in the case of the report

        if (this.userModel.get("postpaid")) {
            $("#geoBlock").remove();
        }

    }

    render(ref) {
        this.renderCollection();
    }

    redrawContacts(evt, filter) {
        if (this.model.get("length") < 5) {
            $('#listview').css('height', 'auto');
        }
        $('#groupsLength').html(this.model.get('groupsLength'));
        super.redrawContacts(evt, filter);
    }

    async renderCollection() {
        await this.renderView();
        await this.fillInGroupsCollection();
        this.CCview.fillInGeographicGroups(this.CCview.model);
    }

    async fillInGroupsCollection() {
        const groupIds = this.groupsCollection.map(model => model.get("id"));

        const setCount = (field, value) => {
            this[field] = value;
            _.each(value, ([id, count]) =>
                Optional.ofNullable(this.groupsCollection.find(model => model.get(model.idAttribute) === id))
                    .ifPresent(model => model.set(field, count)));
        };

        if (groupIds.length > 0) {
            const blockedCount = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/blockedCount",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds: groupIds},
                dataType: 'json'
            });
            setCount("blockedCount", blockedCount);

            //find and fill groups Sizes, for Message report pages
            let queryGroups = this.groupsCollection
                .filter(g => $.inArray(`Group${g.id}`, this.includedGroups) > -1 && g.get("groupType") === "query")
                .map(g => [g.get(g.idAttribute), g.get("query")]);
            if (queryGroups.length !== 0) {

                const queryCountData = await $.ajaxDefaultQ({
                    url: "/CampaignCloud/Subscription/CountByCriterion/many",
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(queryGroups)
                });
                if (queryCountData) {
                    queryCountData.forEach(([id, size]) => {
                        this.groupsCollection.find(function (model) {
                            return model.get("id") === parseInt(id);
                        }).set("size", size);
                        $(`#group-${id} #size-contact`).text(size);
                    });
                }
            }

            if (!this.inIncludedGroupSearch) {
                this.totalIncludedGroupsLength = this.includedGroups.length;
            }
            if (!this.totalIncludedGroupsLength) {
                _.defer(() => {
                    this.hideGroupsSearchBox();
                    this.showNoGroupsToSearchMessage();
                    this.showNoGeoAreasMessage();
                });
            } else {
                _.defer(() => {
                    this.hideNoGroupsToSearchMessage();
                    this.checkIfGeoAreas();
                    this.checkIfGroupsHaveANonGeoArea();
                });
            }

            if (this.inMessageReport) {
                this.hideSelectContactsGroupCheckMark();
            }

            const emailBounced = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/emailBounced",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds: groupIds},
                dataType: 'json'
            });
            setCount("emailBounced", emailBounced);

            const smsBounced = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/smsBounced",
                type: 'get',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds: groupIds},
                dataType: 'json'
            });
            setCount("smsBounced", smsBounced);

            //find and fill groups Sizes, for Message report pages
            queryGroups = this.groupsCollection
                .filter(g => $.inArray(`Group${g.id}`, this.includedGroups) > -1);
            queryGroups.forEach(g => this.renderModel(g));

            queryGroups = queryGroups.filter(g => g.get("groupType") === "query")
                .map(g => [g.get(g.idAttribute), g.get("query")]);

            if (queryGroups.length !== 0) {
                const queryCountData = await $.ajaxDefaultQ({
                    url: "/CampaignCloud/Subscription/CountByCriterion/many",
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(queryGroups)
                });
                if (queryCountData) {
                    queryCountData.forEach(([id, size]) => {
                        this.groupsCollection.find(model => model.get("id") === parseInt(id)).set("size", size);
                        $(`#group-${id} #size-contact`).text(size);
                    });
                }
            }

            if (!this.inIncludedGroupSearch) {
                this.totalIncludedGroupsLength = this.includedGroups.length;
            }
            if (!this.totalIncludedGroupsLength) {
                _.defer(() => {
                    this.hideGroupsSearchBox();
                    this.showNoGroupsToSearchMessage();
                    this.showNoGeoAreasMessage();
                });
            } else {
                _.defer(() => {
                    this.hideNoGroupsToSearchMessage();
                    this.checkIfGeoAreas();
                    this.checkIfGroupsHaveANonGeoArea();
                });
            }

            if (this.inMessageReport) {
                this.hideSelectContactsGroupCheckMark();
            }
        } else {
            this.hideGroupsSearchBox();
            this.showNoGroupsToSearchMessage();
            this.showNoGeoAreasMessage();

            if (this.inMessageReport) {
                this.hideSelectContactsGroupCheckMark();
            }
        }
    }

    showNoGroupsToSearchMessage() {
        this.$("#nogroupssearchmsg").show();
    }

    hideNoGroupsToSearchMessage() {
        this.$("#nogroupssearchmsg").hide();
    }

    showGroupsSearchBox() {
        this.$("#groupsinmgsconfigsearchbox").show();
    }

    hideGroupsSearchBox() {
        this.$("#groupsinmgsconfigsearchbox").hide();
    }

    hideSelectContactsGroupCheckMark() {
        this.$el.find(".selectAllByInitialBtn").hide();
    }

    modelRendering(model, el) {
        var self = this;
        var theId = model.get("subscriptionId");

        var view = new self.SubscriberView({
            model: model,
            CCview: this.CCview,
            inMessageReport: self.inMessageReport,
            postpaid: this.userModel.get("postpaid")
        });
        view.render();
        var elInner = view.el;
        var $2 = $(`#subscriber-${theId}`);
        $2.html('');
        $2.append(elInner);
    }

    renderGroupsCollection() {
        var self = this;
        if(self.includedGroups){
            self.model.set("groupsLength", self.includedGroups.length);

        }
    }

    renderModel(model, scroll) {
        var self = this;
        var tempTemplate = Handlebars.compile("{{tilecolorclass subscription_id}}");
        if ($.inArray("Group" + (model.id), self.includedGroups) > -1) {
            var view = new this.GroupView({model: model, CCview: this.CCview});
            view.render();
            var el = view.el;
            this.$el.find('#grouptiles').append(el);
            if (scroll) {
                el.scrollIntoView();
            }
        }
    }

    newSubscriberView(model) {
        return new this.SubscriberView({model: model, CCview: this.CCview, inMessageReport: this.inMessageReport});
    }

    @on('keyup #groups-container .searchbox')
    doGroupSearch() {
        var text = this.$el.find('#groups-container .searchbox').val().toLowerCase();//.replace(/\s+/g, '');
        if (text.length > 0) {
            var searchresults = _.filter(this.groupsCollection.models, function (m) {
                return m.myText().indexOf(text) !== -1;
            });

            for (var i = 0; i < this.groupsCollection.models.length; i++) {
                var model = this.groupsCollection.models[i];
                if (searchresults.indexOf(model) !== -1) {
                    this.$el.find('#group-' + model.get("id")).show();
                } else {
                    this.$el.find('#group-' + model.get("id")).hide();
                }
            }
        } else {
            this.$el.find('.tile').show();
        }
    }

    createContactsReport(uniqueCodes) {
        var output = [];
        var helper = [];
        var index;

        for (var i = 0; i < uniqueCodes.length; i++) {
            index = helper.indexOf(uniqueCodes[i][0]);
            if (index !== -1) {
                output[index].push(uniqueCodes[i][1]);
            } else {
                helper.push(uniqueCodes[i][0]);
                output.push(uniqueCodes[i]);
            }
        }
        var contactsReport = [];
        output.forEach(function (entry) {
            var sub = {};
            sub.subscriptionId = 0;
            sub.optout = false;
            sub.voucher = false;
            sub.dl = false;
            sub.url = false;
            entry.forEach(function (g) {
                if (isFinite(g)) {
                    sub.subscriptionId = parseInt(g);
                } else if (g === 'OPTOUT') {
                    sub.optout = true;
                } else if (g === 'VOUCHER') {
                    sub.voucher = true;
                } else if (g === 'DL') {
                    sub.dl = true;
                } else if (g === 'URL') {
                    sub.url = true;
                } else if (g === 'SURVEY') {
                    sub.survey = true;
                }
            });
            contactsReport.push(sub);
        });
        return contactsReport;
    }

    showNoGeoAreasMessage() {
        $("#nogeoareasmsg").show();
        $("#geographic-groups-container").hide();
    }

    checkIfGeoAreas() {
        var groups = this.includedGroups;
        for (var i = 0; i < groups.length; i++) {
            if (groups[i].indexOf("q:in bounds") !== -1) {
                $("#nogeoareasmsg").hide();
                $("#geographic-groups-container").show();
                return;
            }
        }
        this.showNoGeoAreasMessage();
    }

    checkIfGroupsHaveANonGeoArea() {
        for (var i = 0; i < this.includedGroups.length; i++) {
            var group = this.includedGroups[i];
            if (group.indexOf("q:in bounds") === -1) {
                this.hideNoGroupsToSearchMessage();
                this.showGroupsSearchBox();
                return;
            }
        }
        this.showNoGroupsToSearchMessage();
        this.hideGroupsSearchBox();
    }
}

// Returning instantiated views can be quite useful for having "state"
export default SubscriberListView;
